<template>
  <span>
    Years: <input type="number" v-model="years" @change="dChange" min="0" max="50" v-focus autofocus/>
    Days: <input type="number" v-model="days" @change="dChange" min="0" max="365"/>
  </span>
</template>        

<script>

export default {

  props: {
    container: null,
    prop: null
  },

  data () {
    return { 
      years: 0,
      days: 0,
      totalDays: null
    }
  },

  async created () {
    console.log("IN EditLengthOfService, days= " + JSON.stringify(this.container[this.prop])) ;

    this.totalDays = this.container[this.prop] ;
    if (!this.totalDays) {
      this.years = 0 ;
      this.days = 0 ;
    }
    else {
      this.years = Math.floor(this.totalDays / 365) ;
      this.days = this.totalDays - (this.years * 365) ;
    }   
  },

  methods: {
    dChange () {
      this.totalDays = parseInt(this.years) * 365 + parseInt(this.days) ;
      console.log("this.years " + this.years  + " this.days " + this.days + ", totalDays set to " + this.totalDays) ;
      this.container[this.prop] = (this.totalDays) ? this.totalDays : null ;
    }
  } 
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Person/EditLengthOfService.vue